// Веб-вклад модуля `characters` — первый ВНЕШНИЙ модуль в интерфейсе.
//
// Два входа, и оба выводятся из этого файла, а не из правок навигации:
//
// 1. Плитка шага ③ панели «Инструменты» воркспейса курса — рядом с `voice` и
//    `tutor`. Это ОСНОВНОЙ вход: персонаж появляется там, где у него есть
//    учебный смысл (добрать то, что не закрылось конспектом и тестом).
//    `kitKind` нет — сессия не вид комплекта темы (см. серверный манифест).
// 2. Самостоятельный раздел `/characters` — каталог и история сессий. В
//    свёрнутую группу Tools попадает автоматически из реестра.
//
// Бейдж = число сессий в локальной `character_sessions`: это «сколько раз
// уже разговаривал», а не учебная очередь. Soft-delete у таблицы нет —
// удаление через tRPC сразу убирает строку из синка.

import { SECTION_ICONS, SECTION_TINT } from "@/components/navigation/section-icons";
import type { WebModuleManifest } from "./_contract";

export const charactersWebManifest = {
	id: "characters",
	icon: SECTION_ICONS.characters,
	labelKey: "nav.characters",
	tint: SECTION_TINT.characters,
	routes: ["/characters"],
	// Чат сессии остаётся в обычном shell (сайдбар + шапка). Глобальный
	// репетитор здесь тоже доступен: человек может уточнить тему у нашего AI,
	// не выходя из разговора с персонажем Hero.

	// Баннер РАЗГРАНИЧИВАЕТ персонажа с репетитором и снимает главное ложное
	// ожидание: разговор с персонажем НЕ засчитывается в прохождение темы.
	// Префикс `sectionIntro`, а не `intro`: ключ `characters:intro.*` уже занят
	// текстом шлюза запуска разговора.
	intro: {
		titleKey: "characters:sectionIntro.title",
		bodyKey: "characters:sectionIntro.body",
		bulletKeys: [
			"characters:sectionIntro.bullets.0",
			"characters:sectionIntro.bullets.1",
			"characters:sectionIntro.bullets.2",
		],
	},

	nav: [
		{
			key: "characters",
			to: "/characters",
			icon: SECTION_ICONS.characters,
			labelKey: "nav.characters",
			order: 80,
			badge: {
				kind: "powersync",
				sql: "SELECT count(*) FROM character_sessions WHERE user_id = ?",
			},
		},
	],

	launch: [
		{
			key: "characters",
			icon: SECTION_ICONS.characters,
			tint: SECTION_TINT.characters,
			titleKey: "launcher.characters",
			hintKey: "launcher.charactersHint",
			to: "/characters",
			order: 40,
		},
	],

	workspaceTools: [
		{
			key: "characters",
			channel: "practice",
			icon: SECTION_ICONS.characters,
			// Требует сети всегда: собеседник живёт у партнёра, и офлайн плитка
			// обязана гаснуть с объяснением, а не открывать неработающий экран.
			requiresOnline: true,
			steps: { 3: 20 },
		},
	],
} satisfies WebModuleManifest;
